import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { adminRetrieveEligibleTrainingItems } from "./retrieve-eligible-training-items";
import type { EligibleTrainingItemsVM } from "@academy-context/shared/domain/types/eligible-training-items";
import { TRAINING_ITEM_TYPE } from "@academy-context/shared/domain/types/training-items";

const initialState: RetrievalState<EligibleTrainingItemsVM> = {
  fetching: "idle",
  data: {
    [TRAINING_ITEM_TYPE.ONE_ON_ONE_LESSONS]: [],
    [TRAINING_ITEM_TYPE.PROVIDER_BATCH]: [],
    [TRAINING_ITEM_TYPE.TEACHER_BATCH]: [],
    [TRAINING_ITEM_TYPE.EXTERNAL_PROVIDER_BATCH]: [],
  },
};

export const adminRetrieveEligibleTrainingItemsReducer = createReducer<RetrievalState<EligibleTrainingItemsVM>>(initialState, builder => {
  builder.addCase(adminRetrieveEligibleTrainingItems.fulfilled, (state, { payload }) => {
    return { ...state, data: payload, fetching: "success" };
  });
  builder.addCase(adminRetrieveEligibleTrainingItems.pending, state => {
    return { ...state, fetching: "pending" };
  });
  builder.addCase(adminRetrieveEligibleTrainingItems.rejected, state => {
    return { ...state, fetching: "failed" };
  });
});
